define('ordersDetailOrderCommentsView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'ordersDetailOrderCommentsEditView',
  'commentsTagsView',
  'ordersDetailOrderCommentsListView',
  'template!ordersDetailOrderCommentsView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  EditView,
  TagsView,
  ListView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'order-comments-view',

    ui: {
      counter: '.counter',
      addButton: '.add'
    },    

    regions: {
      tagsRegion: '.tags-region',
      listRegion: '.list-region'
    },

    events: {
      'click @ui.addButton': 'onAdd'
    },

    onShow: function() {     
      if(Settings.configValue('advancedMode') === true) {
        this.tagsView = new TagsView({showAll: true});
        this.getRegion('tagsRegion').show(this.tagsView);   
        this.tagsView.setSelected('');
      }

      //-------------------
      this.listView = new ListView({       
        model: this.model,
        tagsView: this.tagsView
      });
      this.listView.on('fetched', _.bind(function() {
        this.renderCounter();
      }, this));
      this.getRegion('listRegion').show(this.listView);         
    },

    onRender: function() {         
      this.$el.contextMenu({
        selector: '.comment-view',
        className: '',
        build: _.bind(function () {
          return {
            callback: _.bind(function (key, options) {
              var model = this.listView.collection.get(options.$trigger.data('cid'));
              if (this.options.contextMenuCallback)
                this.options.contextMenuCallback(model, key);
            }, this),
            items: this.options.contextMenuItems
          };
        }, this)
      });      
    }, 

    renderCounter: function () {
      if(this.isDestroyed)
        return;
      
      this.ui.counter.html(this.listView.collection.length);
    },     

    onAdd: function () {
      this.editview = EditView.prototype.open({
        model: new Backbone.Model({comment: ''}),
        title: _.i18n('common.new-comment'),
        onConfirm: _.bind(function (value, tags = []) {
          var currentUserPid = Settings.get('currentUser');
          var comment = new Backbone.Model({
            type: 'order',
            content: value ? value : '',
            externalId: '',
            externalUserId: currentUserPid.externalId ? currentUserPid.externalId : '',
            msgDate: new Date().getTime(),
            title: '',
            user: currentUserPid.secId,
            notSend: true,
            userpid:
            {
              email: currentUserPid.email,
              firstName: currentUserPid.firstName,
              lastName: currentUserPid.lastName,
              logo: currentUserPid.logo
            }
          });

          this.listView.collection.add(comment, { at: 0 });

          //----------------- 
          var tagsIds = [];
          _.each(tags, function (tag) {
            tagsIds.push(tag.get('id'));
          }, this);     
          comment.set('tags', tagsIds.join(','));
          this.model.addComment(comment).done(_.bind(function() {
            this.model.fetch().done(_.bind(function() {
              this.renderCounter();
            }, this));
          }, this));
        }, this)
      });
    }
  });
});
